////////////////////////////////////////////
// FRIENDLY ERROR COPY (SOLANA) — PORT OF index.js friendlyError()
////////////////////////////////////////////
//
// RAW ERROR -> CONSOLE (SUPPORT); THE USER SEES THE FRIENDLY STRING. MOST
// SOLANA PROGRAM ERRORS (PER-WALLET CAP, MIN COMMIT, CLOSED WINDOW, …) ARE
// DECODED SERVER-SIDE (web/server/lib/errors.mjs) AND FORWARDED AS THE
// MESSAGE ITSELF, SO THE TABLE HERE ONLY COVERS WHAT THE SERVER CAN'T:
// WALLET CANCELS, RACE-LOST RESOLUTIONS, AND RPC HICCUPS. RH ERRORS GO
// THROUGH friendlyErrorRh (@/lib/rh/errors) INSTEAD — NEVER THIS.

export function friendlyError(e: unknown): string {

  console.error("[fuze] flow error:", e);
  const m = ((e as Error)?.message || String(e)) || "transaction failed";
  if (m.includes("User rejected"))
    return "Cancelled in your wallet.";
  if (m.includes("AccountNotInitialized") || m.includes("3012"))
    return "Already resolved — your refund or tokens landed earlier.";
  if (m.includes("NOT_DETONATED") || /not.*live yet|LaunchNotDetonated/i.test(m))
    return "The token isn't live on pump.fun yet — your tokens arrive automatically the moment it is.";
  if (/sanitize|blockhash not found|node is behind/i.test(m))
    return "Network hiccup — please try again in a moment.";
  if (/insufficient|debit an account|prior credit/i.test(m))
    return "Not enough SOL in your wallet to cover this plus fees.";
  return m.length > 160 ? m.slice(0, 160) + "…" : m;
}
